module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/images/background.ab2b830b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/images/background.png
// module id = 3245
// module chunks = 11